import React, { useState } from 'react';
import OtpForm from 'react-otp-input';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Slide from '@material-ui/core/Slide';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Base64 } from 'js-base64';
import './Docusign.css';
import config from '../../config/config';

const useStyles = makeStyles({
  root: {
    maxWidth: 400,
    alignItems: 'center',
    paddingBottom: '20px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const BootstrapButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#2A83C2',
    color: 'white',
    borderColor: '#0063cc',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#3399CC',
      borderColor: '#0062cc',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#3399CC',
      borderColor: '#005cbf',
    },
  },
})(Button);

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export default function DocusignOTP() {
  const [verifyCode, setVerifyCode] = React.useState()
  const [uuid, setUuid] = React.useState();
  const [email, setEmail] = React.useState();
  const [error_message, setErrorMessage] = React.useState();
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [loaderVerifyButton, setLoaderVerifyButton] = useState(false);

  const classes = useStyles();
  const { search } = useLocation();

  const handleOnChange = (data) => {
    setVerifyCode(data)
  }

  const handleClick = (Transition) => () => {
    setLoaderVerifyButton(true)
    fetch(`${config.baseUrl}docusign-redirect-to-signing-url?code=${verifyCode}&signer_uuid=${uuid}`)
      .then((res) => res.json()
        .then((data) => {
          if (res.status === 200) {
            setLoaderStatus(!loaderStatus);
            setLoaderVerifyButton(false)
            window.location.replace(data.signing_url);
          } else if (res.status == 401) {
            setErrorMessage(data.message)
            setLoaderVerifyButton(false)
          } else {
            setErrorMessage(data.message)
            setLoaderVerifyButton(false)
          }
        })
      );
  };

  const handleResendCode = () => {
    fetch(`${config.baseUrl}resend-verification-code/${uuid}`)
      .then((res) => res.json())
  }

  useEffect(() => {
    const values = queryString.parse(search);
    if (Object.keys(values).length !== 0) {
      var decodedValues = Base64.decode(values.code);
      var decodeValuesObject = JSON.parse(decodedValues);
      setEmail(decodeValuesObject.email);
      setUuid(decodeValuesObject.signer_uuid);
      if (decodeValuesObject.email) {
        let emailID = decodeValuesObject.email;
        const [name, domain] = emailID.split('@');
        let emailProtected = `${name[0] + name[1] + name[2]}${new Array(name.length - 2).join('*')}@${domain}`;
        setEmail(emailProtected);
      }
    }
  }, [])


  return (
    <div>
      <Grid container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
      >
        {loaderStatus === true ? (
          <div className='container docusign_otp_container'>
            <div className='sub_docusign_otp_container'>
              <h5 className='font-weight-bold'>Opening the document,</h5>
              <div className='d-flex'>
                <div>
                  <h5 className='font-weight-bold'>Please wait &nbsp;</h5>
                </div>
                <div>
                  <span style={{ display: 'flex' }}><div className='dot1'></div><div className='dot2'></div><div className='dot3'></div></span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className='d-none d-md-block'>
              <Grid item style={{ paddingTop: '13%' }}>
                <div>
                  <Card className={classes.root} style={{ boxShadow: '0px 0px 0px 0.2px grey' }}>
                    <CardContent>
                      <Typography className='enter_verification_statement' style={{ fontFamily: 'inherit' }}>
                        Verify Your Identity
                      </Typography>
                      <p className='verification_email'>
                        We have sent 6-digits verification code <br /> to your registered email address <strong>{email ? email : ''}</strong>
                      </p>
                      <img className='docu_sign__image' src="/assets/gif/sign.gif" alt='calque_logo' />
                      <p style={{ marginBottom: '5px', fontSize: '14px' }}>Enter verification code</p>
                      <OtpForm
                        onChange={handleOnChange}
                        numInputs={6}
                        separator={<span></span>}
                        isInputNum={true}
                        secureInput={false}
                        type="number"
                        value={verifyCode}
                        className="docusignOtp"
                        style={{ width: '20px' }}
                      />
                      {
                        error_message ? (<><p id='otp_error_message'>{error_message}</p></>) : ''
                      }
                      <p className="pt-2" style={{ fontSize: '12px' }}>Didn't receive a code? <button id='resendNowTextButton' onClick={handleResendCode}>Resend Code</button></p>
                    </CardContent>
                    <CardActions style={{ justifyContent: 'center' }}>
                      {verifyCode && verifyCode.length == 6 ?
                        (
                          <BootstrapButton onClick={handleClick(SlideTransition)} size="medium" disabled={loaderVerifyButton === true}>Verify Code</BootstrapButton>
                        ) : (
                          <BootstrapButton variant="contained" onClick={handleClick(SlideTransition)} size="medium" disabled style={{ border: '1px solid rgb(235,235,228)' }}>Verify Code</BootstrapButton>
                        )
                      }
                    </CardActions>
                  </Card>
                </div>
              </Grid>
            </div>
            <div className='d-block d-md-none'>
              <Grid item style={{ paddingTop: '5%' }}>
                <div>
                  <Card className={classes.root} style={{ boxShadow: 'none' }}>
                    <CardContent>
                      <Typography className='enter_verification_statement' style={{ fontFamily: 'inherit' }}>
                        Verify Your Identity
                      </Typography>
                      <p className='verification_email'>
                        We have sent 6-digits verification code <br /> to your registered email address <strong>{email ? email : ''}</strong>
                      </p>
                      <img className='docu_sign__image' src="/assets/gif/sign.gif" alt='calque_logo' />
                      <p style={{ marginBottom: '5px', fontSize: '14px' }}>Enter verification code</p>
                      <OtpForm
                        onChange={handleOnChange}
                        numInputs={6}
                        isInputNum={true}
                        separator={<span></span>}
                        secureInput={false}
                        value={verifyCode}
                        className="docusignOtp"
                      />
                      {
                        error_message ? (<><p id='otp_error_message'>{error_message}</p></>) : ''
                      }
                      <p className="pt-2" style={{ fontSize: '12px' }}>Didn't receive a code? <button id='resendNowTextButton' onClick={handleResendCode}>Resend Code</button></p>
                    </CardContent>
                    <CardActions style={{ justifyContent: 'center' }}>
                      {verifyCode && verifyCode.length == 6 ?
                        (
                          <BootstrapButton onClick={handleClick(SlideTransition)} size="medium" disabled={loaderVerifyButton === true}>Verify Code</BootstrapButton>
                        ) : (
                          <BootstrapButton variant="contained" onClick={handleClick(SlideTransition)} size="medium" disabled style={{ border: '1px solid rgb(235,235,228)' }}>Verify Code</BootstrapButton>
                        )
                      }
                    </CardActions>
                  </Card>
                </div>
              </Grid>
            </div>
          </div>
        )}
      </Grid>
    </div>
  );
}